export default "__VITE_ASSET__C9FB$ZNb__"